export const Cast = {
  adult: false,
  gender: 0,
  id: 0,
  known_for_department: "",
  name: "",
  original_name: "",
  popularity: 0,
  profile_path: "",
  cast_id: 0,
  character: "",
  credit_id: "",
  order: 0,
};

export const Crew = {
  adult: false,
  gender: 0,
  id: 0,
  known_for_department: "",
  name: "",
  original_name: "",
  popularity: 0,
  profile_path: "",
  credit_id: "",
  department: "",
  job: "",
};

export const Credits = {
  cast: [],
  crew: [],
};
